<template>
  <b-modal
    id="typeFlyerModal" 
    ref="typeFlyerModal" 
    no-close-on-backdrop
    centered
    v-model="showModal" 
    :title="isUpdate ? 'Atualizar tipo de panfleto' : 'Adicionar tipo de panfleto'" 
    hide-footer
    size="xl"
  >
    <b-row>
      <b-col align="center" cols="6">
        <div v-if="fields.image">
          <img
            :src="getImageAddress(fields.image)"
            alt="Imagem do panfleto"
            style="width: 60%; height: auto;"
          />
        </div>
        <div v-else>
         <i class="fas fa-image" style="font-size: 250px;"></i>
        </div>
      </b-col>
      <b-col cols="6" class="mt-4">
        <b-form>
          <b-form-group label="Nome:">
             <b-form-input 
                v-model="fields.name"
             />
          </b-form-group>
          <label style="margin-bottom: -70px">Rota:</label>
          <b-input-group 
            prepend="seuecomerce.com.br/flyers/id/" 
            class="mt-3" 
          >
            <b-form-input v-model="fields.link" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="12" md="6">
        <b-button @click="closeModal()" variant="outline-danger" block>Cancelar</b-button>
      </b-col>
      <b-col cols="12" md="6">
        <b-button v-if="!isUpdate" @click="save()" variant="success" block>Salvar</b-button>
        <b-button v-else @click="update()" variant="success" block>Atualizar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'TypeFlyerModal',
  emits: ['saveType', 'updateType'],

  data() {
    return {
      loading: false,
      showModal: false,
      isUpdate: false,
      fields: {
        id: null,
        name: "",
        link: "",
        image: null,  
      },
    };
  },
  methods: {
    toggleOpen({ data = null, isUpdate = false }) {
      this.clean();
      this.isUpdate = isUpdate;
      this.showModal = !this.showModal;
      
      if(data) {
        this.fields.name = data.name;
        this.fields.link = data.link;
        this.fields.image = data.image;
        this.fields.id = data.id;
      }
    },
    save() {
      if(this.validation() === false) return;

      this.$emit('saveType', this.fields);
      this.closeModal();
    },
    update() {
      if(this.validation() === false) return;

      this.$emit('updateType', this.fields);
      this.closeModal();
    },
    closeModal() {
      this.showModal = !this.showModal;
    },
    validation() {
      if(!this.fields.name) {
        this.$bvToast.toast('O nome não pode ser vazio', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }

      if (!this.fields.link) {
        this.$bvToast.toast('A rota não pode ser vazio', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }

      return true;
    },
    clean () {
      this.fields = {
        name: "",
        link: "",
      };
      this.isUpdate = false;
    },
    getImageAddress(image) {
      const url = process.env.VUE_APP_FOTOS_AWS + 'panfletos/'; 
      return url + image;
    }
  },
};
</script>
